import { render } from "./jqzysj.vue?vue&type=template&id=164c1f61&scoped=true&ts=true"
import script from "./jqzysj.vue?vue&type=script&lang=ts"
export * from "./jqzysj.vue?vue&type=script&lang=ts"

import "./jqzysj.vue?vue&type=style&index=0&id=164c1f61&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-164c1f61"]])

export default __exports__